var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 26V20C8 18.1 8.56667 16.45 9.7 15.05C10.8333 13.65 12.2667 12.7167 14 12.25V8C14 6.9 14.392 5.958 15.176 5.174C15.96 4.39 16.9013 3.99867 18 4H30C31.1 4 32.042 4.392 32.826 5.176C33.61 5.96 34.0013 6.90134 34 8V12.25C35.7333 12.7167 37.1667 13.65 38.3 15.05C39.4333 16.45 40 18.1 40 20V26H8ZM16 44C13.8 44 11.9167 43.2167 10.35 41.65C8.78333 40.0833 8 38.2 8 36V30H40V36C40 38.2 39.2167 40.0833 37.65 41.65C36.0833 43.2167 34.2 44 32 44H16ZM18 12H22C22 11.4333 22.192 10.958 22.576 10.574C22.96 10.19 23.4347 9.99867 24 10C24.5667 10 25.042 10.192 25.426 10.576C25.81 10.96 26.0013 11.4347 26 12H30V8H18V12Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluide);
export default __webpack_public_path__ + "static/media/Fluide.3abdf619cb61e777d36ddcb5057545d0.svg";
export { ForwardRef as ReactComponent };